import { createSlice } from "@reduxjs/toolkit";

export const NotificationSlice = createSlice({
    name: "Notification" as string,
    initialState: {
        isNotidicationLoader: false as boolean,
        notificationData: null,
    },

    reducers: {
        handleNotificationLoader: (state, action) => {
            state.isNotidicationLoader = action.payload;
        },
        handleNotificationData: (state, action) => {
            state.notificationData = action.payload;
        },
    },
});

export const { handleNotificationLoader, handleNotificationData } = NotificationSlice.actions;
export default NotificationSlice.reducer;
